import React, { useState } from 'react';
import { ClipboardList, Globe, Activity } from 'lucide-react';
import PromemoriaBoard from '../components/kanban/PromemoriaBoard';
import ProgressiSitiBoard from '../components/kanban/ProgressiSitiBoard';
import StatoBoard from '../components/monitor/StatoBoard';

type Tab = 'promemoria' | 'progressi' | 'stato';

const PromemoriaArea: React.FC = () => {
  const [tab, setTab] = useState<Tab>('promemoria');

  const tabs: { key: Tab; label: string; icon: React.ElementType }[] = [
    { key: 'promemoria', label: 'Promemoria', icon: ClipboardList },
    { key: 'progressi', label: 'Progressi Siti Web', icon: Globe },
    { key: 'stato', label: 'Server & Progetti', icon: Activity },
  ];

  return (
    <div className="mx-auto max-w-7xl px-2 py-4 sm:px-4">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">Promemoria</h1>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          Le task tue e di Michel (sincronizzate con iCloud) e lo stato dei progetti web.
        </p>
      </div>

      <div className="mb-5 inline-flex rounded-xl bg-slate-100 p-1 dark:bg-gray-800">
        {tabs.map((t) => {
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
                active
                  ? 'bg-white text-slate-900 shadow-sm dark:bg-gray-900 dark:text-slate-100'
                  : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
              }`}
            >
              <t.icon className="h-4 w-4" />
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === 'promemoria' && <PromemoriaBoard />}
      {tab === 'progressi' && <ProgressiSitiBoard />}
      {tab === 'stato' && <StatoBoard />}
    </div>
  );
};

export default PromemoriaArea;
